import React from 'react'

const CredentialStores = ({...r}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48" {...r}>
      <path
        fill="#00033A"
        fillRule="evenodd"
        stroke="#00033A"
        strokeWidth="0.3"
        d="M30.884 28.004l-.03-.001a.573.573 0 01-.541-.603 1.775 1.775 0 00-.454-1.286 1.757 1.757 0 00-1.225-.586 1.781 1.781 0 00-1.861 1.688.586.586 0 01-.6.543.572.572 0 01-.54-.603c.083-1.614 1.456-2.864 3.06-2.775a2.89 2.89 0 012.015.965 2.92 2.92 0 01.745 2.113.572.572 0 01-.57.545zm-11.636 0l-.03-.001a.573.573 0 01-.54-.603 1.775 1.775 0 00-.454-1.286A1.757 1.757 0 0017 25.528a1.788 1.788 0 00-1.862 1.688.577.577 0 01-.6.543.572.572 0 01-.54-.603c.083-1.614 1.452-2.864 3.06-2.775a2.89 2.89 0 012.015.965 2.92 2.92 0 01.745 2.113.572.572 0 01-.57.545zm3.6 5.256a2.821 2.821 0 01-2.624-1.796.571.571 0 111.063-.421 1.672 1.672 0 003.038.175.57.57 0 111.008.54 2.81 2.81 0 01-2.485 1.502z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#00033A"
        d="M36.941 19.907c-.581.62-1.448.946-2.564.97-2.957-.004-3.234-3.356-3.243-3.458l.002-1.942 6.651.01-.002 2.169c0 .013.023 1.327-.843 2.251zm-1.26 16.511c0 .123-.1.223-.222.223H9.98a.222.222 0 01-.222-.223v-14.86a4.48 4.48 0 001.182.155c1.446-.03 2.584-.477 3.384-1.329.305-.325.529-.678.693-1.026.616 1.25 1.776 2.406 3.782 2.409 1.436-.03 2.566-.475 3.36-1.32.283-.303.494-.631.655-.956.63 1.202 1.775 2.284 3.715 2.287 1.437-.031 2.566-.475 3.36-1.32.28-.301.49-.626.65-.948.608 1.292 1.78 2.513 3.848 2.516a6.06 6.06 0 001.293-.177v14.569zM7.686 17.108l.003-1.663 6.65.01v1.888c0 .014.022 1.329-.845 2.253-.58.62-1.448.945-2.565.969-2.956-.004-3.234-3.355-3.243-3.457zm3.556-8.686l4.599.006-1.255 5.879-6.43-.01 3.085-5.875zm12.067 7.044l6.588.01-.002 1.963c0 .012.022 1.316-.835 2.23-.576.614-1.435.937-2.54.96-1.76-.002-2.56-1.199-2.922-2.177a5.026 5.026 0 01-.29-1.756l.001-1.23zm-7.73-.01l6.587.009-.002 1.961c0 .013.027 1.322-.842 2.241-.575.608-1.432.928-2.534.952-2.928-.004-3.204-3.325-3.212-3.425l.003-1.737zm7.74-7.017l5.01.006 1.375 5.881-6.393-.008.008-5.88zm-1.149 5.878l-6.416-.009 1.255-5.879 5.168.007-.007 5.88zm15.265.021l-6.572-.01-1.362-5.88 5.02.006 2.914 5.884zm1.494.575a.566.566 0 00-.057-.244c-.002-.003-.001-.008-.003-.012l-3.483-7.033a.57.57 0 00-.51-.318l-23.978-.033a.572.572 0 00-.505.306l-3.656 6.963a.567.567 0 00-.19.42l-.002 2.185c.076 1.111.626 2.917 2.072 3.891v15.38a1.37 1.37 0 001.364 1.371H35.46a1.37 1.37 0 001.364-1.371v-15.01a3.85 3.85 0 00.949-.713c1.205-1.284 1.156-3.009 1.154-3.06l.003-2.722z"
      ></path>
      <path
        fill="#fff"
        stroke="#126FFF"
        strokeWidth="1.6"
        d="M35.636 44.51a6.691 6.691 0 100-13.383 6.691 6.691 0 000 13.382z"
      ></path>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M32.727 38.108L34.604 40l3.941-3.636"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#126FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.6"
        d="M32.727 38.108L34.604 40l3.941-3.636"
      ></path>
    </svg>
  )
}

export default CredentialStores